// @ts-nocheck
(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setNavState(navItems, activeIndex, navList) {
    navItems.forEach((item, index) => {
      item.classList.toggle('is-active', index === activeIndex - 1);
    });

    if (!navList) return;

    const activeItem = navItems[activeIndex - 1];
    const activeTitle = activeItem
      ? (activeItem.querySelector('.AboutLabStorySlider__navTitle')?.textContent || '').trim()
      : '';

    navList.setAttribute('data-active-title', activeTitle);
  }

  function setNavProgress(navItems, activeIndex, activeProgress) {
    navItems.forEach((item, index) => {
      let progress = 0;

      if (index < activeIndex - 1) {
        progress = 1;
      } else if (index === activeIndex - 1) {
        progress = activeProgress;
      }

      item.style.setProperty('--nav-progress', progress.toFixed(4));
    });
  }

  function initSection(section) {
    const slideTransitionDuration = 1100;
    const stage = section.querySelector('[data-lab-story-stage]');
    const swiperEl = section.querySelector('[data-lab-story-swiper]');
    const slides = Array.from(section.querySelectorAll('[data-slide-index]'));
    const navItems = Array.from(section.querySelectorAll('[data-nav-index]'));
    const navList = section.querySelector('.AboutLabStorySlider__navList');
    const hasGsapScrollTrigger = Boolean(window.gsap && window.ScrollTrigger);

    if (!stage || !swiperEl || !slides.length || !window.Swiper) return;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: slideTransitionDuration,
      allowTouchMove: false,
      preventInteractionOnTransition: true,
      watchSlidesProgress: true,
      resistanceRatio: 0.7,
      threshold: 6,
      on: {
        slideChange() {
          const activeIndex = this.activeIndex || 0;
          stage.classList.toggle('is-story-start', activeIndex > 0);
          setNavState(navItems, activeIndex, navList);
        }
      }
    });

    const totalPanels = slides.length;
    let maxScroll = 1;
    let sectionTop = 0;
    let currentProgress = 0;
    let targetProgress = 0;
    let animationFrameId = 0;
    let gsapProgressState = null;

    function getViewportHeight() {
      return window.visualViewport?.height || window.innerHeight || 1;
    }

    function refreshMetrics() {
      // Cache offsetTop so scroll events never trigger a layout reflow.
      sectionTop = section.offsetTop;
      maxScroll = Math.max(section.offsetHeight - getViewportHeight(), 1);
    }

    function render(progress) {
      const expandShare = 0.26;
      const expandProgress = clamp(progress / expandShare, 0, 1);
      const storyProgress = clamp((progress - expandShare) / (1 - expandShare), 0, 1);
      const storyPanels = Math.max(totalPanels - 1, 1);
      const panelProgress = storyProgress * storyPanels;
      const activeIndex = storyProgress <= 0
        ? 0
        : clamp(Math.floor(panelProgress) + 1, 1, totalPanels - 1);
      const activeProgress = storyProgress >= 1
        ? 1
        : clamp(panelProgress - Math.floor(panelProgress), 0, 1);

      section.style.setProperty('--lab-story-expand-progress', expandProgress.toFixed(4));
      section.classList.toggle('is-expanded', expandProgress > 0.001);
      stage.classList.toggle('is-expanded', expandProgress > 0.001);
      stage.classList.toggle('is-story-start', activeIndex > 0);

      const targetIndex = activeIndex;
      if (swiper.activeIndex !== targetIndex) {
        // Snap to intro instantly so no story-slide content is visible while
        // the stage is shrinking. Use the full transition only for story→story.
        const dur = targetIndex === 0 ? 0 : slideTransitionDuration;
        swiper.slideTo(targetIndex, dur, false);
      }

      setNavState(navItems, activeIndex, navList);
      setNavProgress(navItems, activeIndex, activeProgress);
    }

    function animate() {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      // Use 2× faster smoothing when scrolling back so the animation catches up
      // quickly instead of trailing for hundreds of ms after the user reverses.
      const goingBack = targetProgress < currentProgress;
      const smoothing = goingBack
        ? (isMobile ? 0.28 : 0.4)
        : (isMobile ? 0.14 : 0.2);

      currentProgress += (targetProgress - currentProgress) * smoothing;

      if (Math.abs(targetProgress - currentProgress) < 0.0015) {
        currentProgress = targetProgress;
      }

      render(currentProgress);

      if (currentProgress !== targetProgress) {
        animationFrameId = window.requestAnimationFrame(animate);
      } else {
        animationFrameId = 0;
      }
    }

    function syncGsapProgress() {
      if (!gsapProgressState) return;

      currentProgress = gsapProgressState.value;
      targetProgress = gsapProgressState.value;
      render(currentProgress);
    }

    function setupGsapScrub() {
      if (!hasGsapScrollTrigger) return false;

      window.gsap.registerPlugin(window.ScrollTrigger);
      gsapProgressState = { value: 0 };

      window.gsap.to(gsapProgressState, {
        value: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 0.5,
          invalidateOnRefresh: true,
          onUpdate: (self) => {
            gsapProgressState.value = self.progress;
            syncGsapProgress();
          }
        }
      });

      return true;
    }

    function updateTargetProgress() {
      const scrollY = window.scrollY || window.pageYOffset || 0;
      targetProgress = clamp((scrollY - sectionTop) / maxScroll, 0, 1);

      // User has scrolled above the section: snap to 0 immediately instead of
      // letting the smoothing loop run for ~500 ms — that tail is what makes
      // scroll feel "locked" when returning to the top of the page.
      if (targetProgress === 0) {
        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
          animationFrameId = 0;
        }
        if (currentProgress !== 0) {
          currentProgress = 0;
          render(0);
        }
        return;
      }

      if (!animationFrameId) {
        animationFrameId = window.requestAnimationFrame(animate);
      }
    }

    function requestUpdate() {
      updateTargetProgress();
    }

    let lastViewportWidth = window.innerWidth;

    function onResize() {
      const viewportWidth = window.innerWidth;
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

      // On touch devices, ignore height-only resizes. Safari mobile fires a
      // continuous stream of resize / visualViewport "resize" events with an
      // unchanged width as its address bar slides in and out during scrolling
      // (most noticeably when scrolling back up). Calling ScrollTrigger.refresh()
      // on each one recalculates EVERY trigger on the page and is what makes the
      // whole page jitter. Only react to real width changes (orientation / actual
      // layout changes) — matching the rest of the cinematic sections.
      if (isTouchDevice && viewportWidth === lastViewportWidth) {
        return;
      }
      lastViewportWidth = viewportWidth;

      refreshMetrics();
      swiper.update();
      if (hasGsapScrollTrigger) {
        window.ScrollTrigger.refresh();
      } else {
        updateTargetProgress();
      }
    }

    refreshMetrics();
    window.addEventListener('resize', onResize);
    window.visualViewport?.addEventListener('resize', onResize);

    if (setupGsapScrub()) {
      render(0);
      return;
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    requestUpdate();
  }

  function boot() {
    document.querySelectorAll('[data-lab-story]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
